<template>
    <div class="modal fade" id="viewSalaryModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printOfferLetter()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printSalaryModal">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="empInfo">
                      <table class="table table-condensed" style="border-width:1px; width:100%;">
                        <thead>
                          <td width="18%"><img :src="this.$store.state.imageBaseUrl + 'logo/' + $store.state.settingRecord.logo" height="90" width="100%"></td>
                          <td class="text-center"><center><h4><strong>{{$store.state.settingRecord.companyName}}</strong> <br> <small>Address : {{$store.state.settingRecord.address}}, {{$store.state.settingRecord.city}}, {{$store.state.settingRecord.state}} - {{$store.state.settingRecord.pin}}
                            <br><span v-if="$store.state.settingRecord.cin">CIN : {{$store.state.settingRecord.cin}},</span> Mobile No - {{$store.state.settingRecord.phone}},<br> Email ID - {{$store.state.settingRecord.email}}, <span v-if="$store.state.settingRecord.url">Website - {{$store.state.settingRecord.url}}</span>
                            </small><br></h4></center></td>
                          <td class="text-right" width="20%" v-if="empInfo.employee"><barcode v-bind:value="empInfo.employee.code" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <div class="row">
                        <div class="col-md-12">
                            <div class="text-center lh-1 mb-2">
                                <p><strong>Payslip for the month of {{ empInfo.remark }}</strong></p> 
                            </div>
                            <table class="mt-4 table table-bordered" width="100%">
                              <thead class="bg-dark text-white" v-if="empInfo.employee">
                                <tr>
                                  <td><strong>EMP Code : </strong> {{ empInfo.employee.code }}</td>
                                  <td><strong>EMP Name :</strong> {{ empInfo.employee.name }}</td>
                                </tr>
                                <tr v-if="empInfo.branch">
                                  <td><strong>Branch Code : </strong> {{ empInfo.branch.branchCode }}</td>
                                  <td><strong>Branch Name :</strong> {{ empInfo.branch.name }}</td>
                                </tr>
                                <tr>
                                  <td><strong> Designation :</strong> <span v-if="empInfo.employee.agent_profile.designation">{{ empInfo.employee.agent_profile.designation.name }}</span></td>
                                  <td><strong>Contact No. :</strong> {{ empInfo.employee.mobile }}</td>
                                </tr>
                                <tr v-if="empInfo.employee.agent_profile">
                                  <td><strong>Bank :</strong> <span v-if="empInfo.employee.agent_profile.bank"> {{ empInfo.employee.agent_profile.bank.name }}</span></td>
                                  <td><strong>Ac No. :</strong> <span v-if="empInfo.employee.agent_profile.accountNumber"> {{ empInfo.employee.agent_profile.accountNumber }}</span></td>
                                </tr>
                                <tr>
                                  <td><strong>Transaction Date. :</strong> {{ empInfo.transactionDate }}</td>
                                  <td><strong>Mode of Pay :</strong> {{ empInfo.payMode }}</td>
                                </tr>
                                
                              </thead>
                            </table>
                            <br>
                            <div class="row">
                              <div class="text-center lh-1 mb-2">
                                <p><strong>Salary Details</strong></p> 
                              </div> 
                              <table class="mt-4 table table-bordered" width="100%">
                                <thead class="bg-dark text-white">
                                  <tr>
                                    <td><strong>Earnings</strong></td>
                                    <td><strong>Amount</strong></td>
                                    <td><strong>Deductions</strong></td>
                                    <td><strong>Amount</strong></td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td scope="row">Basic</td>
                                    <td>{{empInfo.basic}}</td>
                                    <td>PF</td>
                                    <td>{{empInfo.pfDeductions}}</td>
                                  </tr>
                                  <tr>
                                    <td scope="row">Fuel Allowance</td>
                                    <td>{{empInfo.fuelAllowance}}</td>
                                    <td>Advance Deductions</td>
                                    <td>{{empInfo.advanceDeductions}}</td>
                                  </tr>
                                  <tr>
                                    <td scope="row">HRA</td>
                                    <td>{{empInfo.houseRentAllowance}} </td>
                                    <td>Leave Deduction</td>
                                    <td>{{empInfo.leavesDeductions}}</td>
                                  </tr>
                                  <tr>
                                    <td scope="row">Commision</td>
                                    <td>{{empInfo.commission}} </td>
                                    <td>Other Deduction</td>
                                    <td>{{getOtherDeduction(empInfo.otherDeductions)}}</td>
                                  </tr>
                                  <tr>
                                    <td scope="row">Mobile Allowance</td>
                                    <td>{{empInfo.mobileAllowance}} </td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td scope="row">Special Allowance</td>
                                    <td>{{empInfo.specialAllowance}} </td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td scope="row">Other Allowance</td>
                                    <td>{{getOtherDeduction(empInfo.otherAllowance)}}</td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                    
                                  <tr>
                                    <td scope="row"><strong>Earning (TE)</strong> </td>
                                    <td>{{1*empInfo.basic + 1*empInfo.fuelAllowance + 1*empInfo.houseRentAllowance + 1*empInfo.commission + 1*empInfo.mobileAllowance + 1*empInfo.specialAllowance + 1*getOtherDeduction(empInfo.otherAllowance)}}</td>
                                    <td><strong>Total Deduction (TD)</strong></td>
                                    <td>{{(1*empInfo.pfDeductions) +  (1*empInfo.advanceDeductions) + (1*empInfo.leavesDeductions) + (1*getOtherDeduction(empInfo.otherDeductions))}}</td>
                                  </tr>
                                  <tr>
                                    <td scope="row"><strong>Total Salary (TE-TD)</strong></td>
                                    <td><strong>{{empInfo.salary}}</strong></td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>

                              <br><br><br>
                              <p>Net Payable : {{empInfo.salary}}</p> 
                            </div>
                            
                                     <p v-if="empInfo.salary">
                                      <!-- Net Payable (In Words) :Rs {{ payableAmountInWord(empInfo.salary) }}  -->
                                     <br> {{$store.state.settingRecord.companyName}} Authorised Signatory</p>
                            
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import { Printd } from 'printd'
import VueBarcode from 'vue-barcode'
export default {
  name: 'SalarySlip',
  data () {
    return {
      currDate: new Date(),
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      @page {
        size: A4;
        margin: 0;
      }
      
      p {
        font-weight: bold;
        text-align: center;
        padding: 1em;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      table th, table td { border:1px solid #000; padding:.25em; border-collapse: collapse; }`
    }
  },
  methods: {
    getOtherDeduction (val) {
      if (val) {
        var odv = JSON.parse(val)
        return odv
      }
    },
    printOfferLetter () {
      // Get HTML to print from element
      // const prtHtml = document.getElementById('printOfferLetter').innerHTML
      const d = new Printd()
      d.print(document.getElementById('printSalaryModal'), [this.cssText])
    }
    // payableAmountInWord (num) {
    //   var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen ']
    //   var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety']
    //   if (num.length > 9) {
    //     return 'overflow'
    //   }
    //   var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/)
    //   if (!n) return; var str = ''
    //   str += (n[1] !== 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : ''
    //   str += (n[2] !== 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : ''
    //   str += (n[3] !== 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : ''
    //   str += (n[4] !== 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : ''
    //   str += (n[5] !== 0) ? ((str !== '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : ''
    //   return str
    // }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    empInfo: {},
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// SalarySlip.vue?3dcda9b2